<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="1200">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card style="background: rgb(221, 225, 230)">
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <v-stepper v-model="e1" alt-labels style="background: rgb(221, 225, 230)">
              <div class="row justify-content-center mt-4">
                <div class="col-md-12">
                  <v-stepper-header style="background: #fff; box-shadow: none">
                    <v-stepper-step :complete="e1 > 1" step="1"> Datos generales </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="e1 > 2" step="2"> Items de Formula </v-stepper-step>
                  </v-stepper-header>
                </div>
              </div>

              <v-stepper-items>
                <v-stepper-content step="1" class="pl-0 pr-0">
                  <v-card elevation="0" class="mb-4" style="min-height: 500px">
                    <v-card-text>
                      <h6 class="text-h6 black--text">Datos generales</h6>
                      <p class="text-body-2">Complete los datos de la formula</p>

                      <div class="row justify-content-center">
                        <div class="col-md-6">
                          <v-text-field data-vv-as="Nombre" label="Nombre*" name="name" v-model="item.name" v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                          <span class="red--text">{{ errors.first("name") }}</span>

                          <v-combobox
                            v-model="item.product_final"
                            data-vv-as="Producto Resultado"
                            name="product_final"
                            item-text="label"
                            item-value="id"
                            :items="products"
                            label="Producto Resultado*"
                            autocomplete="off"
                            v-validate="'required|combobox_required'"
                            :disabled="isViewModal()"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("product_final") }}</span>

                          <v-text-field 
                            data-vv-as="Cantidad Resultado" 
                            label="Cantidad Resultado*" 
                            name="amount_result" 
                            type="number" 
                            v-model="item.amount_result" 
                            v-validate="'required|decimal'" 
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("amount_result") }}</span>

                          <v-combobox
                            v-model="item.type"
                            data-vv-as="Tipo"
                            name="type"
                            :items="types"
                            item-text="name"
                            item-value="id"
                            label="Tipo*"
                            v-validate="'required'"
                            :disabled="isViewModal()"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("type") }}</span>

                          <v-checkbox label="Habilitado" :disabled="isViewModal()" v-model="item.enabled"></v-checkbox>

                        </div>
                      </div>
                      <div class="row justify-content-center mt-4">
                        <div class="col-md-12">
                          <v-btn class="float-right" color="primary" small @click="next"> Siguiente </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="2" class="pl-0 pr-0">
                  <v-card elevation="0" class="mb-4">
                    <v-card-text style="min-height: 500px">
                      <TableFormulaItems v-if="dialog" :formula="item" :open="dialog" :validator="$validator" :isViewModal="isViewModal()" />

                      <div class="row justify-content-center mt-4">
                        <div class="col-md-12">
                          <v-btn color="primary" @click="e1 = 1" small> Volver </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>

          <v-card-actions style="position: absolute; bottom: 0; width: 100%">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :disabled="e1 <= 1" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import ConstantSections from "@/constants/sections";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import TableFormulaItems from "./TableFormulaItems.vue";
import { formulaService } from "../../../libs/ws/formulaService";

export default {
  mixins: [ModalGenericMixin],
  components: { TableFormulaItems },
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      e1: 1,
      products: [],
      types: []
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
      this.e1 = 1;
    },
  },
  mounted() {
    this.loadProducts();
    this.loadTypes()
  },
  methods: {
    loadTypes() {
      formulaService
        .list_types()
        .then((response) => {
          this.types = response.result;  
        })
        .catch((e) => {
          console.log("types.list error");
          console.log(e);
        });
    },
    next() {
      this.$validator.validate().then((isValid) => {
        if (!isValid) {
          //do whatever you need to do when something failed validation
        } else {
          this.e1 = 2;
        }
      });
    },
    isViewModal() {
      return this.formBtn == "";
    },
    loadProducts() {
      generalService.setSection(ConstantSections.SECTION_PRODUCTS);
      generalService
        .filter()
        .then((response) => {
          console.log("RESPONSE PRODUCTS", response);
          this.products = response.result;
        })
        .catch((e) => {
          console.log("products.filter error");
          console.log(e);
        });
    },
    createItem(e) {
      if (this.loading) return;

      // this.service.setSection(ConstantSections.SECTION_FORMULAS);

      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;
          let data = JSON.parse(JSON.stringify(this.item));
          data["items_arr"] = data.items;
          // data["type"] = data.type.id;
          delete data.items;

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  // this.service.setSection(ConstantSections.SECTION_FORMULAS);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          } else {
            this.service
              .create(data)
              .then((response) => {
                if (response.status && response.result.id > 0) {
                  this.$toast.success("La " + this.modal_title + " se creo correctamente", "OK");
                  this.$emit("updateDialog", false);
                  // this.service.setSection(ConstantSections.SECTION_FORMULAS);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        }
      });
    },
  },
};
</script>
